import React, { useMemo, memo } from "react";
import { PdfViewer } from "orpyx-web-common";
import { ImageViewer } from "./image-viewer/image-viewer";
import { DocumentViewerProps } from "./document-viewer.interface";
import { FileExtension } from "modules/shared/utility/file-extension";

const DocumentViewer = memo((props: DocumentViewerProps) => {
    const ext = new FileExtension(props.name);

    return (
        <>
            {ext.isPdf() && (
                <PdfViewer
                    name={props.name}
                    open={props.open}
                    fileContent={props.fileContent}
                    onClose={props.onClose}
                    domId={props.domId}
                />
            )}
            {ext.isImage() && (
                <ImageViewer
                    name={props.name}
                    open={props.open}
                    fileContent={props.fileContent}
                    onClose={props.onClose}
                    domId={props.domId}
                />
            )}
        </>
    );
});

export default DocumentViewer;
